<h1 mat-dialog-title class="dialog-title" [hidden]="data.alreadyExists">
  {{ 'modal.folder.uploadShareLevel' | transloco }}: <strong>{{ data.folderName }}</strong>
</h1>

<div mat-dialog-content>
  <p class="warning-text" [hidden]="!data.alreadyExists">
    {{ 'modal.folder.infoOverWrite' | transloco }}
  </p>

  <!-- RIGA 1: le due dropdown -->
  <div class="fields" [hidden]="data.alreadyExists">
    <mat-form-field appearance="fill" class="share-level-field">
      <mat-label>{{ 'modal.folder.shareLevel' | transloco }}</mat-label>
      <mat-select [(value)]="data.shareLevel">
        <mat-option *ngFor="let option of shareLevelOptions" [value]="option.value">
          {{ option.text | transloco }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="share-level-field">
      <mat-label>{{ 'modal.folder.shareLevelEdit' | transloco }}</mat-label>
      <mat-select [(value)]="data.shareLevelEdit">
        <mat-option *ngFor="let option of filteredEditOptions" [value]="option.value">
          {{ option.text | transloco }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- RIGA 2: checkbox Keep Settings -->
  <div class="keep-settings-row" [hidden]="data.alreadyExists">
    <mat-checkbox [(ngModel)]="data.keepSettings">
      {{ 'modal.folder.keepSettings' | transloco }}
    </mat-checkbox>
  </div>
</div>

<div class="dialog-buttons">
  <button mat-button class="cancel" (click)="onCancel()">{{ 'recordsManagement.delete.cancel' | transloco }}</button>
  <button mat-button class="confirm" (click)="onConfirm()">{{ 'recordsManagement.delete.confirm' | transloco }}</button>
</div>
